// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606290133/js/" + chunkId + "." + {"44":"b5be74a2","225":"28188324","481":"caef3abb","486":"0cc9449b","770":"e477583a"}[chunkId] + ".0.7182728263842459.chunk.js";
};